export function queryStringToQueryObject(query: string): Record<string, string> {
  return query.split('&').reduce((obj: any, elem: string) => {
    const param = elem.split('=');
    obj[param[0]] = param[1];
    return obj;
  }, []);
}
